import { TGraphValuesType } from '../../../types/redux';

interface ITooltipItems {
  datasetIndex: number;
  yLabel: string;
}

interface IDatasets {
  label: string;
}

interface IData {
  datasets: IDatasets[];
}

export const OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  animation: {
    easing: 'easeInOutQuad' as const,
    duration: 520,
  },
  scales: {
    xAxes: [
      {
        gridLines: {
          color: 'rgba(21, 34, 66, 0.1)',
          lineWidth: 1,
          borderDash: [2, 3],
          zeroLineColor: 'rgba(21, 34, 66, 0.1)',
          zeroLineBorderDash: [2, 3],
        },
        ticks: {
          fontColor: 'rgba(21, 34, 66, 0.4)',
          fontSize: 12,
        },
      },
    ],
    yAxes: [
      {
        gridLines: {
          color: 'rgba(0, 0, 0, 0)',
          lineWidth: 1,
          borderDash: [2, 4],
          zeroLineColor: 'rgba(21, 34, 66, 0.06)',
        },
        ticks: {
          display: true,
          fontColor: 'rgba(21, 34, 66, 0.4)',
          fontSize: 12,
          suggestedMax: 28,
          stepSize: 10,
          suggestedMin: 0,
        },
      },
    ],
  },
  elements: {
    line: {
      tension: 0.4,
    },
  },
  legend: {
    display: false,
  },
  point: {
    backgroundColor: 'white',
  },
  hover: {
    mode: 'index' as const,
    intersect: false,
  },
  tooltips: {
    enabled: true,
    mode: 'index' as const,
    intersect: false,
  },
};

const STEP = 3;

export function getYAxesType(graphValuesType: TGraphValuesType) {
  switch (graphValuesType) {
    case 'thousands':
      return 'тыс.';
    case 'percentage':
      return '%';
  }
}

/**
 * Подготовка опция для отрисовки графика
 */
export function preparedOptions(
  /** Максимальная точка в графики по оси Y */
  suggestedMax: number,
  suggestedMin: number,
  graphValuesType: TGraphValuesType = 'thousands',
) {
  const stepSize = Math.round(suggestedMax / STEP);

  return {
    ...OPTIONS,
    scales: {
      ...OPTIONS.scales,
      yAxes: [
        {
          ...OPTIONS.scales.yAxes[0],
          ticks: {
            ...OPTIONS.scales.yAxes[0].ticks,
            suggestedMax,
            stepSize,
            suggestedMin,
            callback: (value: string) => {
              return `${value} ${getYAxesType(graphValuesType)}`;
            },
          },
        },
      ],
    },
    tooltips: {
      ...OPTIONS.tooltips,
      callbacks: {
        label: (tooltipItems: ITooltipItems, data: IData) => {
          return [
            `${data.datasets[tooltipItems.datasetIndex].label} ${tooltipItems.yLabel} ${getYAxesType(graphValuesType)}`,
          ];
        },
      },
    },
  };
}
